<template>
  <div>
    <!-- <div class="relative">
            <small class="fsize12 bg-white text-dark font-medium"
              >Select Segment Type</small
            >
            <el-select v-model="value" placeholder="Select" class="w-full mt-2">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
    <div class="flex gap-2">
      <div class="w-1/2">
        <h2 class="mb-2 font-semibold fsize16">Enter Segment Name</h2>
        <el-input
          v-model="segmentName"
          placeholder="Enter New Segment Name"
          class="rounded-xl my-2"
        />
      </div>
      <div class="w-1/2">
        <h2 class="mb-2 font-semibold fsize16">Search Users</h2>
        <div class="relative mb-4">
          <el-input
            placeholder="Search"
            class="w-full mt-2"
            v-model="searchInput"
            v-on:input="searchDes"
          ></el-input>
          <div class="absolute topright-adj bg-white cursor-pointer">
            <feather-icon icon="SearchIcon" svgClasses="w-6 h-6" />
          </div>
        </div>
      </div>
    </div>

    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      height="300px"
      @selection-change="handleSelectionChange"
      header-row-class-name="thead-light table-th-color"
    >
      <el-table-column type="selection" width="70"> </el-table-column>
      <el-table-column label="Name" width="120">
        <template v-slot="{ row }">{{
          row.name ? row.name : row.fullName
        }}</template>
      </el-table-column>
      <el-table-column property="mobile" width="180" label="Phone Number">
      </el-table-column>
      <el-table-column property="email" label="Email" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <div class="flex justify-end mt-4">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getAllUsers();
          }
        "
        :per-size="perPage"
        :total="totalUsers"
      ></el-pagination>
    </div>
    <div class="flex justify-end gap-3 mt-6 w-full">
      <div class="relative">
        <vs-button
          @click="handleAdd()"
          type="primary"
          class="rounded-lg bg-primary border-0 text-white font-medium fsize14 py-3 px-8 sm-fsize14"
        >
          Add
        </vs-button>
      </div>
      <div class="relative">
        <vs-button
          @click="handleCancel()"
          type="secondary"
          class="rounded-lg bg-secondary border-0 text-white font-medium fsize14 py-3 px-8 sm-fsize14"
        >
          Cancel
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      tableData: [],
      totalUsers: 0,
      currentPage: 1,
      perPage: 10,
      segmentName: "",
      multipleSelection: [],
      members: [],
      value: [],
      searchInput: "",
    };
  },
  computed: {
    ...mapState("admin", ["login"]),
  },

  methods: {
    handleCancel() {
      this.$emit("handleAddNewSegment");
      this.members.length = 0;
      this.multipleSelection = [];
    },
    async handleAdd() {
      // console.log(this.login);
      try {
        let payload = {
          name: this.segmentName,
          adminId: this.login._id,
        };
        let data = await this.$store.dispatch("segment/add", payload);

        if (data.code == 200) {
          if (this.multipleSelection.length != 0) {
            for (let i = 0; i < this.multipleSelection.length; i++) {
              // this.members = this.multipleSelection;
              this.members.push(this.multipleSelection[i]);
            }
          }
          let record = {};
          Object.assign(record, { segmentid: data.data._id });

          let user = [];

          for (let i = 0; i < this.members.length; i++) {
            user.push({ userid: this.members[i]._id });
          }
          // for (let i = 0; i < this.multipleSelection.length; i++) {
          //   user.push({ userid: this.multipleSelection[i]._id });
          // }
          Object.assign(record, { user: user });
          // console.log(record);

          let addMember = await this.$store.dispatch(
            "segment/addMembers",
            record
          );

          if (addMember.code == 200) {
            this.segmentName = "";
            this.multipleSelection = [];
            this.member = [];
            this.$emit("handleAddNewSegment");
          }
        }
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    searchDes: _.debounce(function () {
      this.getAllUsers();
    }, 500),
    async getAllUsers() {
      try {
        let payload = {
          perPage: this.perPage,
          page: this.currentPage,
        };
        if (this.searchInput)
          Object.assign(payload, { search: this.searchInput });
        let data = await this.$store.dispatch("user/getAllUsers", payload);
        this.tableData = data.registeredUser;
        this.totalUsers = data.registeredUserLength;
        if (this.multipleSelection.length != 0) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            // this.members = this.multipleSelection;
            this.members.push(this.multipleSelection[i]);
          }
        }
        // if (this.members.length != 0) {
        //   for (let i = 0; i < this.members.length; i++) {
        //     if (this.members[i]._id == this.tableData[i]._id) {
        //       console.log(this.members[i]._id);
        //       console.log(this.tableData[i]._id);
        //       this.value.push(this.members[i]);
        //     }
        //   }
        // }
        // if (this.value.length != 0) {
        //   this.handleSelectionChange(this.value);
        // }
      } catch (err) {
        console.log(err);
      }
    },
    // async getAllUser() {
    //   try {
    //     let data = await this.$store.dispatch("user/getAllUsers", {
    //       perPage: this.perPage,
    //       page: this.currentPage,
    //     });
    //     this.tableData = data.registeredUser;
    //     this.totalUsers = data.registeredUserLength;

    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    handleSelectionChange(val) {
      // console.log(val);
      // this.multipleSelection = val[val.length - 1]._id;
      // if (val.length != 0) {
      this.members = val;
      // }
    },
  },
  mounted() {
    this.getAllUsers();
  },
};
</script>
